import React from "react";
import { footerIcon, footerLogo,footerFb,footerTel,footerInsta } from "../../../../../images";
import { Link } from "react-router-dom";
import { getBrandName } from "../../Components/getBrandName";
import { NavLink } from "react-router-dom";

const LandingPage = () => {
  const { normalizedBrand, brandName } = getBrandName();

  return (
    <div className="new-footer-section">
      <div className="row">
        <div className="col-lg-3">{/*col-lg-7*/} 

          <Link to="/"><img src={footerLogo} className="img-fluid footerLogo" alt="footerLogo"></img></Link>
          {/* <div className="d-flex mt-4 mb-4 social-icon">
              <img src={footerFb} className="img-fluid me-4" alt="fb"></img>
              <img src={footerInsta} className="img-fluid me-4" alt="insta"></img>
              <img src={footerTel} className="img-fluid" alt="tel"></img>
          </div> */}
        </div>
        <div className="col-lg-3">
            {/* Company */}
            {/* <div className="col-6 col-md-3"> */}
              <ul className="list-unstyled small">
              <h6 className=" mb-3 new-footer-text">Links</h6>
                <li>
                  <NavLink to="/" className="new-footer-link">Home</NavLink></li>
                <li><NavLink to="/about-us" className="new-footer-link">About Us</NavLink></li>
                <li><NavLink to="/pricing" className="new-footer-link">Pricing</NavLink></li>
                <li><NavLink to="/blog" className="new-footer-link">Blog</NavLink></li>
                <li><NavLink to="/contact" className="new-footer-link">Contact Us</NavLink></li>
                <li><NavLink to="/faq" className="new-footer-link">FAQs</NavLink></li>
              </ul>
            {/* </div> */}
        </div>
        <div className="col-lg-3">
            {/* Company */}
            {/* <div className="col-6 col-md-3"> */}
              <ul className="list-unstyled small">
              <h6 className=" mb-3 new-footer-text">Important Links</h6>
                <div className="d-none d-md-flex"><NavLink to="/privacy-policy" className="new-footer-link">Privacy Policy</NavLink></div>
                <div className="d-none d-md-flex"><NavLink to="/terms-condition" className="new-footer-link">Terms & Conditions</NavLink></div>
              </ul>
            {/* </div> */}
        </div>
        <div className="d-block d-md-flex justify-content-between align-items-center footer-below">
          <div className="d-flex d-md-none justify-content-center fs-5">Privacy policy</div>
          <div className="d-flex d-md-none justify-content-center fs-5 mb-2">Terms & Condition</div>
          <div className="d-flex align-items-center">
            <img src={footerIcon} alt="footerIcon" className="img-fluid footerIcon"></img>&nbsp;&nbsp;
         <div className="">
          Copyright © {new Date().getFullYear()} {brandName} All Rights Reserved
         </div>
          </div>
          {/* <div className="d-none d-md-flex"><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></div>
          <div className="d-none d-md-flex"><Link to="/terms-condition" className="footer-link">Terms & Conditions</Link></div> */}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
